/*  ========================================================================
    # Section - Heroshowreel
    ========================================================================  */

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import bem from '../../helpers/bem';
import useLocalization from '../../hooks/useLocalization';
import useTranslation from '../../hooks/useTranslation';
import useTabVisible from '../../hooks/useTabVisible';

const HeroShowreel = ({ lightboxVideo }) => {
  const __ = useTranslation();

  // useRef
  const dialogRef = useRef(null);
  const lightboxVideoRef = useRef(null);
  const [videoPlay, setVideoPlay] = useState(false);
  const [pauseByTabLeaving, setPauseByTabLeaving] = useState(false);
  const videoElements = document.getElementsByClassName('s-hero-showreel__video');

  // Determine if the tab is visible
  const tabVisible = useTabVisible();

  // Icons
  const localize = useLocalization();
  const iconPlay = `${localize('svgSprite')}#play`;
  const iconClose = `${localize('svgSprite')}#cross`;

  // Handle dialog toggle
  const handleLightboxToggle = () => {
    if (dialogRef.current && dialogRef.current.open) {
      for (const video of videoElements) {
        video.play();
      }
      setVideoPlay(false);
      lightboxVideoRef.current.pause();
      dialogRef.current.close();
      document.body.style = null;
    } else {
      setVideoPlay(true);
      for (const video of videoElements) {
        video.pause();
      }
      dialogRef.current.showModal();
      lightboxVideoRef.current.currentTime = 0;
      lightboxVideoRef.current.play();
      document.body.style = 'overflow: hidden';
    }
  };

  // Pause video and close lightbox if tab is not visible
  useEffect(() => {
    if (!tabVisible && videoPlay) {
      lightboxVideoRef.current.pause();
      setVideoPlay(false);
      setPauseByTabLeaving(true);
    } else if (pauseByTabLeaving) {
      setVideoPlay(true);
      setPauseByTabLeaving(false);
      if (dialogRef.current && dialogRef.current.open) {
        lightboxVideoRef.current.play();
      }
    }
  }, [tabVisible]);

  return (
    <>
      <div className={bem('s-hero-showreel', 'playbutton-wrapper')} onClick={handleLightboxToggle}>
        <button
          title={__('play-video-title')}
          aria-label={__('play-video-title')}
          className={`${bem('c-button', '', { black: true, icon: true })} ${bem(
            's-hero-showreel',
            'video-control'
          )}`}
        >
          <svg viewBox='0 0 200 200'>
            <use href={iconPlay} />
          </svg>
        </button>
      </div>
      <dialog
        className={bem('s-hero-showreel', 'lightbox')}
        ref={dialogRef}
        onClose={() => (document.body.style = null)} //eslint-disable-line
      >
        <button
          title={__('lightbox-close-button')}
          aria-label={__('lightbox-close-button')}
          className={`${bem('s-hero-showreel', 'lightbox-control')} ${bem('c-button', '', {
            icon: true,
            white: true
          })}`}
          onClick={handleLightboxToggle}
        >
          <svg viewBox='0 0 200 200'>
            <use href={iconClose} />
          </svg>
        </button>
        <div className={bem('s-hero-showreel', 'lightbox-video')}>
          <picture>
            <video
              ref={lightboxVideoRef}
              src={lightboxVideo.url}
              title={lightboxVideo.description}
              controls
            />
          </picture>
        </div>
      </dialog>
    </>
  );
};

HeroShowreel.propTypes = {
  lightboxVideo: PropTypes.object
};

export default HeroShowreel;
